document.addEventListener('DOMContentLoaded', function () {
  console.log('🟢 Script activo. Esperando que aparezca #form-Select');

  const observer = new MutationObserver(() => {
    const originalSelect = document.querySelector('#form-Select');

    if (originalSelect) {
      console.log('✅ Select detectado');

      // Clonar el select
      const clonedSelect = originalSelect.cloneNode(true);
      const options = Array.from(clonedSelect.options);

      // Eliminar la opción "Default / Default"
      const defaultOption = options.find(opt => opt.text.trim() === 'Default / Default');
      if (defaultOption) {
        console.log('🗑️ Eliminando opción "Default / Default" del clon');
        defaultOption.remove();
      }

      // Asegurar que alguna opción esté seleccionada
      if (!clonedSelect.value || clonedSelect.selectedIndex === -1) {
        const firstValid = clonedSelect.querySelector('option:not([disabled])');
        if (firstValid) {
          firstValid.selected = true;
          clonedSelect.value = firstValid.value;
          console.log(`✔️ Seleccionando automáticamente: ${firstValid.text}`);
        }
      }

      // Reemplazar el original por el clon
      originalSelect.replaceWith(clonedSelect);

      // Lanzar evento 'change' para notificar a Shopify
      const event = new Event('change', { bubbles: true });
      clonedSelect.dispatchEvent(event);

      observer.disconnect();
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
});
